import { isUndefined } from 'lodash';
import { ValuationApproachGPC } from 'api/models/ValuationApproachGPC';
import { ValuationApproachGPT } from 'api/models/ValuationApproachGPT';
import {
  SELECTED_DATABASE_VALUE,
  SPECIFIED_LABEL,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/constants';
import { GPCBaseColumn } from 'pages/Valuations/approaches/guidelinePublicCompanies/types';
import { GPTBaseColumn } from 'pages/ValuationsAllocation/approaches/TransactionComps/types';

type TableColumnType = GPTBaseColumn | GPCBaseColumn;
type ApproachType = ValuationApproachGPT | ValuationApproachGPC;
type ApproachTypeKeys = keyof ApproachType;

const addApproachDataInColumn = (tableColumn: TableColumnType, approach: ApproachType) => {
  const tempCableColumn = { ...tableColumn } as any;
  const isTransactionComps = Boolean((approach as ValuationApproachGPT).gpt_transactions);
  const propPrefix = isTransactionComps ? tableColumn.prefix ?? tableColumn.id : tableColumn.id;
  // pull the necessary data out of the approach object and add it to the column
  tempCableColumn.selected_multiple = approach[`${propPrefix}_selected_multiple` as ApproachTypeKeys];
  tempCableColumn.selection = approach[`${propPrefix}_selection` as ApproachTypeKeys];
  if (tempCableColumn.selection === SELECTED_DATABASE_VALUE) {
    tempCableColumn.selection = SPECIFIED_LABEL;
  }
  const weighting = approach[`${propPrefix}_weighting` as ApproachTypeKeys];
  if (!isUndefined(weighting)) {
    tempCableColumn.weighting = (approach[`${propPrefix}_weighting` as ApproachTypeKeys] as number) * 100;
  }
  return { ...tempCableColumn };
};

export default addApproachDataInColumn;
